import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataSet, InvestmentType, Project, ProjectPhase } from 'src/app/interfaces/investmentcontrolling/inco-project';
import { InvestmentControllingService } from 'src/app/services/investment-controlling.service';
import { HistoryProjectDialogComponent } from '../../master-data/history-project-dialog/history-project-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-recent-projects-tracker',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './recent-projects-tracker.component.html',
  styleUrls: ['./recent-projects-tracker.component.less']
})
export class RecentProjectsTrackerComponent implements OnInit {
  searchTerm!: string;
  rows: Project[] = [];
  dataSource = new MatTableDataSource<Project>([]);
  enumSelectors: { key: string, values: { id: number | string | null, label: string }[] }[] = [];
  multiprojects: DataSet[] = [];
  investmentTypes: InvestmentType[] = [];
  projectPhases: ProjectPhase[] = [];

  constructor(private readonly dialogForm: MatDialog,
    private readonly toastrService: ToastrService,
    private readonly incoService: InvestmentControllingService) { }

  displayedColumns: string[] = ['mgmtId', 'mgmtName', 'projectId', 'projectTitle', 'createdAt', 'multiproject', 'investmentType',
    'informationTechnology', 'manufacturing', 'fieldOperations', 'researchDevelopment', 'bigR', 'maintenance', 'expansion', 'focus', 'phase', 'changeLog'];

  ngOnInit(): void {
    this.getProjectPhase();
    this.getInvestmentType();
    this.getMultiprojects();
    this.loadData();
  }

  loadData() {
    this.incoService.getAllProjects(this, true, function (tthis: RecentProjectsTrackerComponent, result: Project[]) {
      tthis.rows = result;
      tthis.dataSource.data = result;
    }
      , null)
  }

  applySearch(): void {
    const term = this.searchTerm?.trim().toLowerCase();

    if (!term) {
      this.dataSource.data = this.rows;
      return;
    }

    this.dataSource.data = this.rows.filter(row =>
      row.mgmtId?.toLowerCase().includes(term) || row.mgmtName?.toLowerCase().includes(term)
    );
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.dataSource.data = this.rows;
  }

  getProjectPhase() {
    this.incoService.getProjectPhase(
      this,
      function (tthis: RecentProjectsTrackerComponent, result: ProjectPhase[]) {
        tthis.projectPhases = result;
      },
      null
    );
  }

  getInvestmentType() {
    this.incoService.getInvestmentType(
      this,
      function (tthis: RecentProjectsTrackerComponent, result: InvestmentType[]) {
        tthis.investmentTypes = result;
      },
      null
    );
  }

  getMultiprojects() {
    this.incoService.getMultiprojects(
      this,
      function (tthis: RecentProjectsTrackerComponent, result: DataSet[]) {
        tthis.multiprojects = result;
      },
      null
    );
  }

  getBooleanDisplay(value: boolean): string {
    return value ? 'YES' : 'NO';
  }

  viewprojectHistory(project: any) {
    this.incoService.getProjectHistory(
      project.id,
      this,
      (tthis: RecentProjectsTrackerComponent, history: any[]) => {
        tthis.dialogForm.open(HistoryProjectDialogComponent, {
          width: '1400px',
          data: {
            id: project.id,
            projectTitle: project.projectTitle,
            history: history,
            investmentTypes: this.investmentTypes,
            projectPhases: this.projectPhases,
            multiprojects: this.multiprojects
          }
        });
      },
      (tthis: RecentProjectsTrackerComponent, error: any) => {
        tthis.toastrService.error('No se pudo obtener el historial del proyecto.');
      }
    );
  }

}